import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { Box, Body, Vec3 } from 'cannon-es';

export class Die {

	static SideLength = 0.02; // 2 cm

	static dieModel;
	static async loadObject() {
		// Load model test
		const loader = new GLTFLoader();
		const result = await loader.loadAsync( 'models/dice/scene.gltf' );
		Die.dieModel = result.scene.children[0];
		Die.dieModel.scale.set(Die.SideLength/2,Die.SideLength/2,Die.SideLength/2);
		Die.dieModel.traverse( function( node ) {
			if ( node.isMesh ) {
				node.castShadow = true;
				//node.receiveShadow = true;
			}
		} );
	}

	constructor( material ) {

		// Three

		this.model = Die.dieModel.clone();
		this.model.castShadow = true;

		// Cannon

		this.body = new Body({
			mass: 0.005, // 5 g
			material: material,
		});
		this.body.addShape(
			new Box( new Vec3( Die.SideLength/2, Die.SideLength/2, Die.SideLength/2 ) )
		);

		// Roll lock
		
		this.rollLock = false;
	}

	roll( position = 0 ) {

		if ( this.rollLock ) {
			return;
		}

		const formation = [ [0,0,0], [1,0,0], [0,0,1], [1,0,1], [0,1,0] ];
		this.body.position.set(
			formation[position][0] * Die.SideLength * 1.5,
			formation[position][1] * Die.SideLength * 1.5 + 0.1,
			formation[position][2] * Die.SideLength * 1.5 + 0.4,
		);
		this.body.quaternion.setFromEuler(
			Math.random() * Math.PI * 2,
			Math.random() * Math.PI,
			Math.random() * Math.PI * 2,
		);
		this.body.angularVelocity.set(
			randomBetween( -10, 10 ),
			randomBetween( -10, 10 ),
			randomBetween( -10, 10 ),
		);
		this.body.velocity.set(
			0,
			0.1,
			-1,
		);
	}

	toggleRollLock() {
		this.rollLock = ! this.rollLock;
	}

	updateMesh() {
		this.model.position.copy(   this.body.position   );
		this.model.quaternion.copy( this.body.quaternion );
	}
};

function randomBetween( a, b ) {
	return Math.random() * (b - a) + a;
}
